export var NotificationChannel;
(function (NotificationChannel) {
    NotificationChannel["InApp"] = "inApp";
    NotificationChannel["Push"] = "push";
})(NotificationChannel || (NotificationChannel = {}));
export class NotificationChannelHelper {
    static getName(channel) {
        switch (channel) {
            case NotificationChannel.InApp:
                return $t('%ZtL');
            case NotificationChannel.Push:
                return $t('%ZtN');
        }
    }
    static isKnown(channel) {
        return Object.values(NotificationChannel).includes(channel);
    }
}
//# sourceMappingURL=NotificationChannel.js.map